import { FETCH_TOPICS } from './constants'

const initialState = {
  isFetching: false,
  items: [],
  deviceId: null
}

export default function topicsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TOPICS.REQUEST: {
      return {
        ...state,
        isFetching: true,
        deviceId: action.deviceId
      }
    }
    case FETCH_TOPICS.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        items: action.topics
      }
    }
    case FETCH_TOPICS.FAILURE: {
      return {
        ...state,
        isFetching: false,
        items: []
      }
    }
    default: {
      return state
    }
  }
}
